import React, {useState} from "react"
import {Box, Button, IconButton, Modal, Typography} from '@mui/material'
import Grid from '@mui/material/Grid2';
import CloseIcon from "@mui/icons-material/Close";
import {useTranslation} from "react-i18next";
import {Theme} from "@mui/material/styles";
import {useSelector} from "react-redux";
import {RootState} from "../../../Redux";
import api from '../../../Services/api'

const style = (theme: Theme) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    width: 800,
    boxShadow: 24,
    p: 4,
});

const buttonStyle = (theme: Theme) => ({
    opacity: 0.8,
    borderWidth: 2,
    borderStyle: 'solid',
    borderRadius: '10%',
    borderColor: theme.palette.secondary.main,
    boxShadow: '2px 2px 8px 0px rgba(0,0,0,0.2)',
    '& .MuiSvgIcon-root': {
        color: theme.palette.secondary.main,
    },
})

const CloseButton = ({sx}) => {
    const { t } = useTranslation()

    const chainId = useSelector((state: RootState) => state.ui?.settings?.chain?.id)
    const stationId = useSelector((state: RootState) => state.ui?.settings?.station?.id)

    const [open, setOpen] = useState(false);
    const [processing, setProcessing] = useState(false);
    const allowClose = useSelector((state: RootState) => state.selfService?.allowClose)
    const serviceCardInfo = useSelector((state: RootState) => {
        const info = {
            token: state.selfService?.serviceCardToken,
            isNew: state.selfService?.serviceCardIsNew,
            isProvisional: state.selfService?.serviceCardIsProvisional,
        }

        if (! info.token && state.reservation?.reservation?.token) {
            info.token = state.reservation?.reservation?.token
            info.isProvisional = !! state.reservation?.reservation?.confirmIn
        }

        return info
    })

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleExit = () => {
        setProcessing(true)

        if (serviceCardInfo.isNew && serviceCardInfo.token && serviceCardInfo.isProvisional) {
            const { discardReservation } = api.create()
            discardReservation({reservation: {chainId, stationId}, token: serviceCardInfo.token}).finally(() => window.location.reload())
        } else if (serviceCardInfo.isNew && serviceCardInfo.token && ! serviceCardInfo.isProvisional) {
            const { cancelReservation } = api.create()
            cancelReservation(serviceCardInfo.token).finally(() => window.location.reload())
        } else {
            window.location.reload()
        }
    }
    
    return (<>
        {allowClose &&
            <IconButton
                aria-label="close"
                onClick={handleOpen}
                sx={buttonStyle}
                style={{padding: '12px'}}
            >
                <CloseIcon />
            </IconButton>
        }
        <Modal
            open={open}
            onClose={handleClose}
            sx={sx}
        >
            <Box className="closeModal" sx={style}>
                <Grid container wrap="nowrap" direction="column" alignItems="center" justifyContent="center" spacing={4}  style={processing ? {opacity: 0.5} : undefined}>
                    <Typography variant="h4">
                        {t('selfService.doYouWantToAbort')}
                    </Typography>
                    <Typography>
                        {t('selfService.abortHelpText')}
                    </Typography>
                    <Grid container wrap="nowrap" direction="row" size={12} alignItems="center" justifyContent="center" spacing={24}>
                        <Button
                            disabled={processing}
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={handleClose}
                        >
                            {t('common.no')}
                        </Button>
                        <Button
                            disabled={processing}
                            variant="contained"
                            size="small"
                            color="secondary"
                            onClick={handleExit}
                        >
                            {t('common.yes')}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    </>)
}

export default CloseButton
